<template>
  <div class="container">
    <!-- <van-skeleton title :row="3" avatar-shape="square" :loading="imgloading"> -->
      <van-swipe :autoplay="4000" class="carousel" height="45vw" :duration="500">
        <van-swipe-item v-for="(image, index) in images" :key="index" @click="bannerlink(image.link)">
          <img :src="image.img" />
        </van-swipe-item>
      </van-swipe>
    <!-- </van-skeleton> -->
    <form action="/">
      <van-search
        v-model="search"
        placeholder="请输入搜索关键词"
        @search="searchfunc"
      />
    </form>
    <div class="context">
      <van-list
        v-model="loading"
        :immediate-check="false"
        :finished="finished"
        finished-text="没有更多啦"
        @load="load_more"
      >
      <div class="main" v-for="item in list" :key="item.index" @click="urlchange(item.id)">
        <img :src="item.img" alt="">
        <div class="right">
          <p class="name">{{item.name}}</p>
          <p class="info" v-html="item.intro"></p>
          <p class="location">{{item.address}}</p>
          <div class="flex">
            <div>
              <i class="el-icon-user"></i>
              <span>：{{item.count}}</span>
            </div>
            <div>
              <p>创建于{{item.create_date}}</p>
            </div>
          </div>
        </div>
      </div>
      </van-list>
    </div>
    <div class="fixed">
      <el-button type="warning" @click="linkto">志愿组织入驻</el-button>
    </div>
  </div>
</template>
<script>
export default {
  name:'orginazation',
  data() {
    return {
      images:[
        
      ],
      list:[],
      loading:false,
      finished:false,
      page: 1,
      imgloading:true,
      search:'',
    }
  },
  created(){
    this.$axios({
      method:'post',
      url:'/api/org/zy_list',
      data:this.qs.stringify({
        token:sessionStorage.getItem('wmtoken')
      })
    }).then(res => {
      console.log(res.data);
      if(res.data.code == 0){
        this.list = res.data.data.list;
      }else{
        that.$toast(res.data.msg);
      }
    })
    this.$axios({
      method:'post',
      url:'/api/index/index',
      data:this.qs.stringify({
        zjyuid:sessionStorage.getItem('uid'),
        mobile:sessionStorage.getItem('mobile'),
      })
    }).then(res => {
      console.log(res.data);
      for(let i in res.data.data.banner_list){
        switch(res.data.data.banner_list[i].place){
          case 'org_top':
            this.images.push(res.data.data.banner_list[i]);
            break;
          default:
            break;
        }
      }
      this.imgloading = false;
    })
  },
  methods:{
    searchfunc(val){
      this.initlist();
      this.list = [];
      this.finished = false;
      this.page = 1;
    },
    initlist(){
      this.page = 1;
      this.finished = false;
      this.loading = false;
      this.list = [];
      this.$axios({
        method:'post',
        url:'/api/org/zy_list',
        data:this.qs.stringify({
          keyword:this.search
        })
      }).then(res => {
        console.log(res.data);
        if(res.data.code == 0){
          this.list = res.data.data.list;
        }else{
          that.$toast(res.data.msg);
        }
        this.$forceUpdate();
      })
    },
    urlchange(id){
      this.$router.push({
        name:'orginazationdetail',
        query:{
          id:id
        }
      })
    },
    bannerlink(link){
      location.href = link;
    },
    linkto(){
      this.$router.push('/createorg');
    },
    load_more(){
      this.page += 1;
      var that = this;
      setTimeout(function(){
        that.$axios({
          method:'post',
          url:'/api/org/zy_list',
          data:that.qs.stringify({
            token:sessionStorage.getItem('wmtoken'),
            page:that.page,
            keyword:that.search
          })
        }).then(res => {
          console.log(res.data);
          if(res.data.code == 0){
            that.list = that.list.concat(res.data.data.list);
          }
          that.loading = false;
          if (res.data.data.list.length == 0) {  //数据全部加载完成
            that.finished = true;
          }else{
            that.finished = false;
          }
        })
      },500)
      
    },
  }
}
</script>
<style scoped>
.container{
  background: #F2F2F2;
  min-height: 100vh;
}
img{
  width: 100%;
  display: block;
}
/* vue-touch不能上下滑动的问题 */
.wrapper {
  touch-action: pan-y !important;
  height: 100%;
}
.menu-container{
  height: 100%;
}
.carousel img{
  height: 100%;
}
.context{
  padding: 10px;
  margin-bottom: 50px;
}
.main{
  padding: 10px;
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  background: white;
  border-radius: 5px;
}
.main img{
  width: 35%;
  height: 20vw;
  display: block;
  object-fit: contain;
  margin-right: 5%;
  border-radius: 5px;
}
.right{
  width: 60%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
.flex{
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  font-size: 12px;
}
.info{
  font-size: 12px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.location{
  font-size: 12px;
  color: cornflowerblue;
}
.name{
  font-weight: bold;
}
.el-button{
  background: #CAB586;
  width: 60%;
  display: block;
  margin: 10px auto;
  border: 0;
}
.fixed{
  width: 100%;
  position: fixed;
  background: white;
  bottom: 0;
  left: 0;
}
.van-skeleton{
  background: white;
}
</style>


// WEBPACK FOOTER //
// src/components/orginazation.vue